import ScrollItem from './ScrollItem';
import './SectionDecoration.css'
import sectionDecorationLeft from '../img/section-decoration-left.webp'
import sectionDecorationRight from '../img/section-decoration-right.webp'

export default function SectionDecoration() {
    return (
        <>
            <div className="decoration--left">
                <ScrollItem>
                    <img src={sectionDecorationLeft} alt="section decoration" />
                </ScrollItem>
            </div>
            <div className="decoration--right">
                <ScrollItem>
                    <img src={sectionDecorationRight} alt="section decoration" />
                </ScrollItem>
            </div>
        </>
    )
}